import {
  Component,
  OnInit,
} from "@angular/core";
import { KycService } from "@app/core/kyc.service";
import { Router } from "@angular/router";
import { routerTransition } from "@app/router.animations";
import { NavTabService } from "@app/core/navTab.service";
import { onQuestiones, onDefaultAnswerNeeds, onCheckAnswer } from "@app/features/coverage/coverage";

import * as _ from "lodash";
declare var $;

@Component({
  selector: "app-coverage",
  templateUrl: "./coverage.component.html",
  animations: [routerTransition()],
  host: { "[@routerTransition]": "" }
})
export class CoverageComponent implements OnInit {
  questionCoverages: any;
  questionNeeds: any;
  questionRiskProfiles: any;
  data: any;
  dataConfigNeeds: any;
  isError: boolean = true;
  constructor(
    private kycService: KycService,
    private router: Router,
    private navTabService: NavTabService
  ) {
  }

  ngOnInit() {
    const { questionCoverages, questionRiskProfiles } = this.kycService.kyc.coverage
    const { questionNeedAssessments } = this.kycService.kyc.needs
    this.questionCoverages = questionCoverages;
    this.questionNeeds = Object.values(_.groupBy(_.map(questionNeedAssessments, (item) => (item.KYCQuestion.Order === 3 || item.KYCQuestion.Order === 0) ? item : undefined).filter(item => item), 'KYCQuestionId')).reverse()
    this.questionRiskProfiles = Object.values(_.groupBy(questionRiskProfiles, 'KYCQuestionId'));
    this.data = [this.questionCoverages, ...this.questionRiskProfiles, ...this.questionNeeds];
    this.dataConfigNeeds = _.map(questionNeedAssessments, item => (item.KYCQuestion.Order === 3 || item.KYCQuestion.Order === 0) ? undefined : item).filter(item => item);
    this.isError = onCheckAnswer(this.data)
  }

  setInsuranceActive(answer: {
    KYCQuestionId: string;
    Id: string;
    Name: string;
    Order: number;
    Answer: boolean;
  }, questiones) {
    onQuestiones(answer, questiones);
    const isAnswer = onCheckAnswer(this.data)
    if (isAnswer) {
      this.isError = false;
    } else {
      this.isError = true;
    }
  }

  goToNextPage() {
    const isAnswer = onCheckAnswer(this.data)
    const data = _.map(this.kycService.kyc.needs.questionNeedAssessments, item => item['KYCQuestion'].Id === "80d4a0fc-b0a2-4f1c-bc1a-e8e660201f41" ? item : undefined).filter(item => item)
    let tenant = this.kycService.getTenant();
    if (data[2].Answer && isAnswer) {
      onDefaultAnswerNeeds(this.dataConfigNeeds);
      this.kycService.kyc.needs.completed = true;
      this.router.navigateByUrl("/" + tenant + "/journey/my-financial");
      this.navTabService.setActiveTab("financial");
      this.kycService.kyc.coverage.completed = true;
      this.isError = true;
    } else if ((data[0].Answer || data[1].Answer) && isAnswer) {
      this.kycService.kyc.coverage.completed = true;
      this.router.navigateByUrl("/" + tenant + "/journey/my-needs");
      this.navTabService.setActiveTab("needs");
      this.isError = true;
    }else {
      this.isError = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/features/coverage/coverage.component.ts